import React from 'react';
import SpeedDial from '@manakin/core/dist/SpeedDial';
import SpeedDialAction from '@manakin/core/dist/SpeedDialAction';
import Add from '@manakin/core/dist/icons/Add';
import Create from '@manakin/core/dist/icons/Create';
import { useTranslation } from 'react-i18next';

const SpeedDials = (props) => {
	const { addTitle, onAddClick } = props;
	const { t } = useTranslation();

	return (
		<SpeedDial>
			<SpeedDialAction icon={<Add />} tooltipTitle={addTitle || t('common.add')} onClick={onAddClick} />
		</SpeedDial>
	);
};

export default SpeedDials;
